// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__U_tM6","wrapper":"styles_wrapper__bjBhF","wrapper_tables":"styles_wrapper_tables__wl9C4"};